var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBestBuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 110,
    viewBox: "0 0 187 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_1179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.354V48.538H24.7048C34.4285 48.538 43.4143 45.1252 43.4143 35.1006C43.4143 28.3236 38.5322 25.23 33.1623 23.6106C36.434 22.2983 40.1454 19.5414 40.1454 13.7621C40.1454 6.36506 32.8059 1.354 22.9243 1.354H0ZM15.1345 12.3432H20.6986C22.9637 12.3432 24.6909 14.1174 24.6909 15.9182C24.6909 17.5912 22.8962 19.3819 20.6986 19.3819H15.1345V12.3432ZM15.1345 29.1748H22.4792C25.0432 29.1748 27.1948 31.1221 27.1948 33.3479C27.1948 35.7114 25.1825 37.674 22.034 37.674H15.1345V29.1748Z",
    fill: "#1C252C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2412 53.6851V100.869H36.946C46.6697 100.869 55.6555 97.4563 55.6555 87.4316C55.6555 80.6546 50.7734 77.561 45.4035 75.9417C48.6752 74.6293 52.3866 71.8724 52.3866 66.0931C52.3866 58.6961 45.0471 53.6851 35.1655 53.6851H12.2412ZM27.3757 64.6743H32.9399C35.2049 64.6743 36.9321 66.4485 36.9321 68.2492C36.9321 69.9223 35.1374 71.7129 32.9399 71.7129H27.3757V64.6743ZM27.3757 81.5058H34.7204C37.2844 81.5058 39.436 83.4532 39.436 85.6789C39.436 88.0425 37.4237 90.0051 34.2753 90.0051H27.3757V81.5058Z",
    fill: "#1C252C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6025 48.5326V1.34863H82.6613V12.744H59.6925V18.9314H78.3436V29.6145H59.6925V37.1818H82.6613V48.5326H44.6025Z",
    fill: "#1C252C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.278 49.883C113.991 49.883 122.56 43.7723 122.56 33.8699C122.56 17.8886 101.77 20.3478 101.77 15.372C101.77 13.45 103.791 12.43 105.864 12.43C109.437 12.43 112.018 14.7836 112.018 14.7836L120.962 6.26701C117.385 2.86238 111.735 0 104.123 0C92.6926 0 85.2143 6.7844 85.2143 14.9684C85.2143 31.1529 105.705 28.8039 105.705 33.8821C105.705 35.6623 103.992 37.4531 100.886 37.4531C97.3593 37.4531 94.5656 35.3242 92.3913 33.5179L83.3945 42.0952C87.0173 45.624 92.8334 49.883 103.278 49.883Z",
    fill: "#1C252C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.207 48.5326V12.6995H121.743V1.34863H161.805V12.6995H149.341V48.5326H134.207Z",
    fill: "#1C252C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1758 53.6514H71.2658V81.9173C71.2658 84.7876 74.1224 87.4326 77.1007 87.4326C79.9102 87.4326 82.7502 85.044 82.7502 81.7663V53.6514H97.7956V81.574C97.7956 92.6539 88.5966 101.492 76.702 101.492C64.7396 101.492 56.1758 91.8734 56.1758 80.9703V53.6514Z",
    fill: "#1C252C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.402 100.835V83.9752L98.666 53.6514H113.934L123.969 69.8987L134.039 53.6514H149.342L131.536 84.1485V100.835H116.402Z",
    fill: "#1C252C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.342 79.4746L140.439 88.3773V100.396L149.342 109.298H187V79.4746H149.342Z",
    fill: "#FFED31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.879 94.381C147.879 95.4873 146.982 96.3841 145.876 96.3841C144.77 96.3841 143.873 95.4873 143.873 94.381C143.873 93.2747 144.77 92.3779 145.876 92.3779C146.982 92.3779 147.879 93.2747 147.879 94.381Z",
    fill: "#1C252C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_1179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 109.299,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestBuy);
export default __webpack_public_path__ + "static/media/BestBuy.0abab77d660c6c94231590b3fd2eac69.svg";
export { ForwardRef as ReactComponent };